<template>
  <loading v-if="status === 'true'"/>
  <div class="container-fluid table-responsive" v-else>
    <table class="table table-striped table-bordered">
      <thead>
      <tr>
        <th>پیگیری کد تخفیف</th>
        <th>عنوان</th>
        <th> قیمت (تومان)</th>
        <th>تعداد دورها</th>
        <th>تعداد دوره باقی مانده</th>
        <th>عملیات خرید</th>
        <th>وضعیت</th>
        <th>وضعیت پرداخت</th>
        <th>تاریخ و ساعت خرید</th>
        <th>تاریخ انقضا کد تخفیف</th>
        <th>مهلت پرداخت</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(list , index) in listCredit">
        <td data-label="پیگیری کد تخفیف"> {{ list.tracking_code }}</td>
        <td data-label="عنوان">{{ list.panel.title }}</td>
        <td data-label="قیمت (تومان)">
          {{
            number.numberFormats(checkType(list?.panel?.price, list?.types, list?.panel?.buyCredit, list?.panel?.git_online))
          }}
        </td>
        <td data-label="تعداد دورها">{{ list.panel.discount }}</td>
        <td data-label="تعداد دوره باقی مانده">
          {{ list.counts }}

          <a href="#">
            <i class="fas fa-clipboard-list" data-bs-toggle="modal" data-bs-target="#staticBackdrop"></i>
          </a>
          <!-- Modal -->
          <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
               aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="staticBackdropLabel">لیست کاربرانی که دوره برای آن ها ثبت شده است</h5>
                </div>
                <div class="modal-body">
                  {{}}
                  <table class="table   table-striped table-bordered">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th>نام کاربر</th>
                      <th>شماره تماس</th>
                      <th>تاریخ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row , index) in list.panel.purchases">
                      <td data-label="#">{{ index + 1 }}</td>
                      <td data-label="نام کاربر">{{ row.customer_name }}</td>
                      <td data-label="شماره تماس">{{ row.customer_mobile }}</td>
                      <td data-label="تاریخ">{{ datePersian.DatePersianTime(row.created_at) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td data-label="لیست کد تخفیف">
          <button type="button" class="btn btn-outline-secondary" data-bs-toggle="modal"
                  :data-bs-target="'#staticBackdrop' +list?.id">
            <i class="fa fa-eye"></i>
          </button>
          <div class="modal fade" :id="'staticBackdrop'+list?.id" data-bs-backdrop="static" data-bs-keyboard="false"
               tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog  modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="staticBackdropLabel"></h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="بستن"></button>
                </div>
                <div class="modal-body">
                  <div class="d-flex flex-row justify-content-center">
                    <div class="p-2 w-100">
                      <div class="input-group">
                        <input type="tel" class="form-control text-end" v-model="data.mobile" maxlength="11"
                               placeholder="لطفا شماره همراه کاربر مورد نظر را وارد کنید">
                        <div class="input-group-append">
                          <button class="btn btn-outline-success" type="button" @click="getUsers()"
                                  v-if="loadings === 'false' ">
                            <i class="fa fa-search"></i>
                          </button>
                          <button class="btn loadings mybtn form-control btn-danger " v-else>
                            <div class="spinner-grow fo spinner-grow-sm"><span class="sr-only">  </span></div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-row mt-3 justify-content-center" v-if="textError !='' ">
                    <div class="p-2 text-danger  text-center ">
                      <h6>{{ textError }}</h6>
                    </div>
                  </div>
                  <div class="d-flex flex-row mt-3 justify-content-center" v-if="resultUsers?.billing_phone_number">
                    <div class="p-2 text-danger  text-center ">
                      <h6>لطفا قبل از ثبت شماره حتما آن را چک کنید. درصورت ورود اشتباه امکان تصحیح وجود ندارد</h6>
                    </div>
                  </div>
                  <div class="d-flex flex-row mt-3 table-bordered" v-if="resultUsers?.billing_phone_number">
                    <div class="ms-5 col-md-3">
                      <span class=""> نام کاربر</span> <span class="ms-2 text-secondary">{{ resultUsers.name }}</span>
                    </div>
                    <div class="ms-5 col-md-3">
                      <span class="">شماره تماس</span> <span
                        class="ms-2 text-secondary">{{ resultUsers.billing_phone_number }}</span>
                    </div>
                    <div class="ms-5 col-md-3">
                       <span>
                           <button class="btn btn-success form-control"
                                   @click="buyProucts(resultUsers.user_id, list?.panel_id , resultUsers.name )"
                                   v-if="loadingBuy === 'false' ">خرید دوره برای کاربر</button>

                                 <button class="btn loadings mybtn form-control btn-danger " v-else>
                            <div class="spinner-grow fo spinner-grow-sm"><span class="sr-only">  </span></div>
                          </button>
                       </span>
                    </div>
                  </div>
                </div>
                <div class="modal-footer mt-3 ">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
                </div>
              </div>
            </div>
          </div>
        </td>
        <td data-label="وضعیت">{{ getStatus(list.status) }}</td>
        <td data-label="وضعیت پرداخت">
          <div v-if="list.payment_code">
            <span class="btn text-success ">پرداخت شده</span>
          </div>
          <div v-else>
            <form :action="config.BASE_URL+'/creditPayment'" method="post">
              <input hidden type="hidden " name="id" v-model="list.panel_id">
              <input hidden type="hidden" name="user_id" v-model="user_id">
              <input hidden type="hidden" name="phone" v-model="phone_number">
              <input hidden type="hidden" name="email" v-model="email">
              <button type="submit" class="btn btn-danger" style="font-size: 10px">پرداخت آنلاین
              </button>
            </form>
          </div>
        </td>
        <td data-label="تاریخ و ساعت خرید">{{ datePersian.DatePersianTime(list.created_at) }}</td>
        <td data-label="تاریخ انقضا کد تخفیف">{{ datePersian.converDatePersian(list.date_credits) }}</td>
        <td data-label="مهلت پرداخت">{{ datePersian.converDatePersian(list.credit_payment) }}</td>
      </tr>
      <tr>
        <td colspan="11">
          <nav class="text-danger">
            <ul class="pagination  " style="justify-content: center;">
              <li class="page-item">
                <button class="btn btn-light " :disabled="!paginatetion.first_page_url" href="#"
                        v-on:click="myPaginate(paginatetion.first_page_url)" title="اولین"><i
                    class="fa fa-angle-double-right"></i></button>
                <button class="btn btn-light " :disabled="!paginatetion.prev_page_url" href="#"
                        v-on:click="myPaginate(paginatetion.prev_page_url)" title="قبلی"><i
                    class="fa fa-angle-right"></i></button>
              </li>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <li class="page-item">
                <button class="btn btn-light" v-on:click="myPaginate(paginatetion.next_page_url)"
                        :disabled="!paginatetion.next_page_url" title="بعدی">
                  <i class="fa fa-angle-left"></i></button>
                <!---->
                <button class="btn btn-light " :disabled="!paginatetion.last_page_url" href="#"
                        v-on:click="myPaginate(paginatetion.last_page_url)" title="آخرین"><i
                    class="fa fa-angle-double-left"></i></button>
              </li>
            </ul>
          </nav>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup>
import axios from "axios";
import {$ref} from "vue/macros";
import config from "../../../../config/config.json";
import * as datePersian from "@/common/helpers/DatePersian"
import {useToast} from "vue-toastification";
import * as number from "@/common/helpers/Number";
import Loading from "@/agent/components/Layout/loadings/index.vue";
import * as errors from "@/common/helpers/errors"
import panel from "../../../customer/components/panel/index.vue";

let loadings = $ref('false');
let loadingBuy = $ref('false');

let status = $ref('true');

setTimeout(() => {
  status = 'false';
}, 1500);

const toast = useToast();
let url = `${config.BASE_URL}/credits`;
let paginatetion = $ref({})
let listCredit = $ref({})
let result = JSON.parse(localStorage.getItem('users'));
let user_id = $ref(result.id);
let phone_number = $ref(result.phone_number);
let email = $ref(result.email);
let mobile = $ref();
const data = {
  "mobile": "",
  "user_id": "",
  "name": "",
  "panel_id": ""
}
let textError = "";
let resultUsers = $ref({});

async function buyProucts(user_id, panel_id, name) {
  loadingBuy = 'true';
  try {
    data.user_id = user_id;
    data.panel_id = panel_id
    data.name = name
    const response = await axios.post('buyWordPressUser/buy', data);
    if (response.data.status === "true") {
      resultUsers = "";
      data.mobile = ""
      toast.success(response.data.messages);
      await getCaredit()
      loadingBuy = 'false';
      return false;
    }
    return true;
  } catch (error) {
    loadingBuy = 'false';
    errors.myErrors(error)
  }
}

async function getUsers() {
  loadings = 'true';
  textError = "";
  try {
    const response = await axios.post('buyWordPressUser/serach', data);
    let result = response.data.data.data;
    loadings = 'false';
    if (response.data.data.status === "false") {
      textError = "کاربری با این شماره یافت نشده. لطفا ابتدا با این شماره در سایت هلو آکادمی ثبت نام کنید";
      return false;
    }
    if (!result.billing_phone_number) {
      toast.error("شماره تماس برای این  کاربر یافت نشده است");
      resultUsers = "";
      return false;
    }
    resultUsers = response.data.data.data;
  } catch (error) {
    loadings = 'false';
    errors.myErrors(error)
  }
}

async function getCaredit() {
  try {
    const res = await axios.get(url);
    listCredit = (res.data.status) ? res.data.data.data : ""

    makePaginatetion(res.data.data);
  } catch (e) {
    console.log(e)
  }
}

function checkType(price, types, buyCredit, git_online) {
  if (types === 'credit') {
    return Credit(price, buyCredit)
  }
  if (types === 'payment') {
    return Credit(price, git_online)
  }
  return price
}

function Credit(price, discountPercentage) {
  if (discountPercentage) {
    if (price) {
      let percentageAmount = (price * discountPercentage) / 100;
      return parseInt(price) - parseInt(percentageAmount);
    }
  }
}

function makePaginatetion(data) {
  let paginatetions = {
    current_page: data.current_page,
    last_page_url: data.last_page_url,
    next_page_url: data.next_page_url,
    prev_page_url: data.prev_page_url,
    first_page_url: data.first_page_url
  }
  paginatetion = paginatetions;
}

function getStatus(status) {
  return (status === 'true') ? 'فعال' : 'غیر فعال'
}

function myPaginate(urls) {
  url = urls;
  getCaredit()
}

getCaredit()
</script>